import { render } from "./UnboxOverview.vue?vue&type=template&id=bd6417c4&scoped=true"
import script from "./UnboxOverview.vue?vue&type=script&lang=js"
export * from "./UnboxOverview.vue?vue&type=script&lang=js"

import "./UnboxOverview.vue?vue&type=style&index=0&id=bd6417c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6417c4"]])

export default __exports__